var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0H6.54545C5.46048 0 4.41994 0.421427 3.65275 1.17157C2.88555 1.92172 2.45455 2.93913 2.45455 4V6.4H0V9.6H2.45455V16H5.72727V9.6H8.18182L9 6.4H5.72727V4C5.72727 3.78783 5.81347 3.58434 5.96691 3.43431C6.12035 3.28429 6.32846 3.2 6.54545 3.2H9V0Z",
    fill: "#393184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBookIcon);
export default __webpack_public_path__ + "static/media/face-book-icon.bd9986bb9a3d440671f118504ecf649b.svg";
export { ForwardRef as ReactComponent };